import * as React from "react";
import "../scss/departureheaderentry.scss"
export interface DepartureHeaderEntryProps {
    width: number,
    germanHeaderText: string,
    englishHeaderText: string,
    textAlignment?: any
}
export class DepartureHeaderCompoment extends React.Component<DepartureHeaderEntryProps, { width: number, germanHeaderText: string, englishHeaderText: string, textAlignment: any }> {
    render() {
        return (
            <div className="departureheader-entry-container" style={{ width: this.props.width, textAlign: this.props.textAlignment }}>
                <div className="departureheader-entry-germanText">
                    <span>{this.props.germanHeaderText}</span>
                </div>
                <div className="departureheader-entry-englishText">
                    <span>{this.props.englishHeaderText}</span>
                </div>
            </div>
        );
    }
}
export default DepartureHeaderCompoment;